<template>
    <main>
        <div class="container-fluid">
            <div class="row">
                <div class="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                    <div class="mainButton">
                        <breadcrumbs></breadcrumbs>
                    </div>
                    <div class="page-toolbar">
                        <div class="page-title">
                            <span class="title">Email</span>
                            <span class="star"> <i class="fa-solid fa-star"></i></span>
                        </div>
                        <div class="page-create-button">
                            <router-link to="/modules/emails/edit" class="btn-create">Create</router-link>
                        </div>
                        <div class="page-filter">
                            <input type="search" value="" placeholder="Searching..." class="form-control"
                                v-on:click="openAction">
                            <CustomSearch v-bind:class="{ active: isActive }" @searchEvent="childMethod"
                                @openAction="openAction"></CustomSearch>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <GenericList v-if="generic" ref="loadGeneric"></GenericList>
        <CustomList v-else ref="loadCustom"></CustomList>

    </main>
</template>
<script>
    import { ref } from "vue";
    import breadcrumbs from "@/views/modules/Emails/MenuList.vue";
    import lang from "@/views/modules/Emails/language/en";
    import GenericList from "@/components/layout/shared/generic/ListView.vue";
    import CustomList from "@/views/modules/Emails/ListView.vue";
    import CustomSearch from "@/views/modules/Emails/SearchView.vue";
    export default {
        name: "list-opportunity",
        components: {
            breadcrumbs,
            GenericList,
            CustomList,
            CustomSearch,
        },
        data() {
            return {
                generic: true,
                isActive: false,
                metaList: [
                    {
                        label: lang.LBL_SUBJECT,
                        link: true,
                        moduleName: 'Emails',
                        routePath: 'emails',
                        linkOtherModule: false,
                        isSort: true,
                        field_name: 'subject'

                    },
                    {
                        label: lang.LBL_FROM_EMAIL,
                        link: false,
                        linkOtherModule: false,
                        isSort: true,
                        field_name: 'fromname'

                    },
                    {
                        label: lang.LBL_TO_EMAIL,
                        link: false,
                        moduleName: 'Emails',
                        linkOtherModule: false,
                        isSort: true,
                        field_name: 'to'

                    },
                    {
                        label: lang.LBL_DATE_SEND,
                        link: false,
                        linkOtherModule: false,
                        isSort: true,
                        field_name: 'date_sent'
                    },
                    {
                        label: lang.LBL_STATUS,
                        link: false,
                        linkOtherModule: false,
                        isSort: true,
                        field_name: 'status'
                    },
                ],
                columns: ['subject', 'fromname', 'to', 'date_sent', 'status'],
            }
        },
        mounted() {
            this.childMethod();
        },
        methods: {
            childMethod(search = '') {
                if (this.generic == true) {
                    this.$refs.loadGeneric.loadGenericView(this.metaList, this.columns, search);
                }
            },
            openAction() {
                this.isActive = !this.isActive;
            },
        }
    }

</script>